import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=42fc1830&scoped=true"
import script from "./UserGroupDetail.vue?vue&type=script&lang=js"
export * from "./UserGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=42fc1830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc1830",
  null
  
)

export default component.exports